import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';

import { DistributorQueryKeys } from '../config/queryKeys';
import { getRequestHeaders } from '../lib/headers';
import { LegacyCoopClient } from '../lib/LegacyCoopClient';
import type { DistributorListResponse } from '../lib/schemas';
import { DistributorListResponseSchema } from '../lib/schemas';
import type { PresetUseQueryOptions } from '../lib/types';

export function useDistributorList<TData = DistributorListResponse>(
  options?: PresetUseQueryOptions<DistributorListResponse, TData>,
) {
  const session = useWmgSession();

  const { data, ...query } = useQuery({
    queryKey: DistributorQueryKeys.list(),
    queryFn: async () => {
      const responseData = await LegacyCoopClient.get('labels/distributors', {
        headers: getRequestHeaders(session.token),
      }).json<DistributorListResponse>();

      return DistributorListResponseSchema.parse({
        ...responseData,
        // mocking paginated response payload because the endpoint doesn't support pagination
        total: responseData.data.length,
        page: 1,
        totalPages: 1,
      });
    },
    placeholderData: keepPreviousData,
    ...options,
  });

  return { distributorList: data, ...query };
}
